// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__fN3za","left":"styles_left__1mGVm"};